module.exports = __webpack_public_path__ + "static/media/img3-3.5697a929.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/biosense/diff/img3-3.png
// module id = 1531
// module chunks = 3